import { ROLES, ROLE } from '@api/users/constants';
import * as utils from '@utils/form';

export const FORM_FIELDS = {
  NAME: {
    name: 'name',
    label: 'User name',
    disabled: true,
  },
  ROLE: {
    name: 'cmsRole',
    label: 'CMS Role',
    rules: [{ type: 'string', required: true, enum: ROLES.map((role) => role.value) }],
    options: ROLES,
  },
  EVENT: {
    name: 'event',
    label: 'Event',
    serialize: utils.relatedEntitySerializer,
    deserialize: utils.relatedEntityDeserializer,
    deserializeError: utils.deserializeErrorRelatedField,
    rules: [
      ({ getFieldValue }) => ({
        validator: (rule, value) => {
          if (!value?.id && getFieldValue(FORM_FIELDS.ROLE.name) === ROLE.LOC_EDITOR) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject(
              `${FORM_FIELDS.EVENT.label} is required when ${FORM_FIELDS.ROLE.label} is set to ${ROLE.LOC_EDITOR}`,
            );
          }

          return Promise.resolve();
        },
      }),
    ],
  },
};
